module.exports = __webpack_public_path__ + "img/imagen_cabezote.60181c49.jpg";